import React, { Component } from 'react';
import styled from 'styled-components';

import { capitalize } from 'helpers';
import WP from 'WP';

import DatePicker from './DatePicker';
import InputField from '../Rental/Forms/InputField';
import DropdownList from '../Rental/Forms/DropdownList';
import Checkbox from '../Rental/Forms/Checkbox';
import TextArea from '../Rental/Forms/TextArea';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';

import Media from 'css/Media';

class ConferenceOrderInput extends Component {

    constructor(props) {
        super(props)
        this.state = {
            duration: true,
            numPersons: true,
            drinksAndSnacks: false,
            lunch: false,
            dinner: false
        }
        this.datePickr = React.createRef();
    }

    handleDateChange(dateObj, dateStr, instance) {
        if(dateObj.length > 0) {
            this.props.setDate(dateObj);
        }
    }

    validateField = e => {
        if(this.props[e.target.name].length > 0) {
            this.setState({[e.target.name]: true})
        } else this.setState({[e.target.name]: false})
    }

    handleClick = e => {
        this.props.handleDropdownChange(e)
    }

    render() {
        const { 
            id, 
            venueOptions,
            numPersons, 
            duration, 
            message, 
            defaultValue,
            dateValid, 
            drinksAndSnacks,
            lunch,
            dinner,
            text } = this.props;
            console.log('dv',defaultValue) 

        return (
            <FormGrid id={id}>
                <VenueGridElement
                    colStart={{default: 1, s: 1, m: 1}}
                    colEnd={{default: 8, s: 12, m: 6}}
                    rowStart={{default: 1}}
                >
                    <DropdownList 
                        name="venueName"
                        defaultValue={defaultValue}
                        onChange={e => this.handleClick(e)}
                        options={venueOptions}
                        label={WP.trans.selectConferenceVenue}
                    />
                </VenueGridElement>
                <PeopleGridElement
                    colStart={{default: 1, s: 1, m: 7}}
                    colEnd={{default: 8, s: 12, m: 12}}
                    rowStart={{default: 2, s: 2, m: 1}}
                >
                    <InputField 
                        id="numPersons"
                        label={WP.trans.amountOfGuests}
                        type="text"
                        onChange={e => this.props.handleInputChange(e)}
                        onBlur={this.validateField}
                        value={numPersons}
                        validated={this.state.numPersons}
                    />
                </PeopleGridElement>
                <DatePickerGridElement
                    colStart={{default: 1, s: 1, m: 1}}
                    colEnd={{default: 8, s: 12, m: 6}}
                    rowStart={{default: 3, s: 3, m: 2}}
                >
                        <DatePicker
                            dateHandler={(dateObjects, dateStr, instance) => this.handleDateChange(dateObjects, dateStr, instance)}
                            reference={this.datePickr}
                            valid={dateValid}
                        />
                </DatePickerGridElement>
                <DaysGridElement
                    colStart={{default: 1, s: 1, m: 7}}
                    colEnd={{default: 8, s: 12, m: 12}}
                    rowStart={{default: 4, s: 4, m: 2}}
                >
                    <InputField 
                        id="duration"
                        label={WP.trans.desiredDuration}
                        type="text"
                        onChange={e => this.props.handleInputChange(e)}
                        onBlur={this.validateField}
                        value={duration}
                        validated={this.state.duration}
                    />
                </DaysGridElement>
                <OptionsHtmlGridElement
                    colStart={{default: 1, s: 1}}
                    colEnd={{default: 8, s: 12}}
                    rowStart={{default: 5, m: 3}}
                >
                    <OptionsHtml content>{text}</OptionsHtml>
                </OptionsHtmlGridElement>
                <CheckboxGridElement
                    colStart={{default: 1, s: 1}}
                    colEnd={{default: 8, s: 12}}
                    rowStart={{default: 6, m: 4}}
                >
                    <Checkbox 
                        text={WP.trans.beverageRequest} 
                        name="drinksAndSnacks"
                        onChange={e => this.props.handleCheck(e)}
                        checked={drinksAndSnacks}
                    />
                </CheckboxGridElement>
                <CheckboxGridElement
                    colStart={{default: 1, s: 1}}
                    colEnd={{default: 8, s: 12}}
                    rowStart={{default: 7, m: 5}}
                >
                    <Checkbox 
                        text={WP.trans.lunchRequest} 
                        name="lunch"
                        onChange={e => this.props.handleCheck(e)}
                        checked={lunch}
                    />
                </CheckboxGridElement>
                <LastCheckboxGridElement
                    colStart={{default: 1, s: 1}}
                    colEnd={{default: 8, s: 12}}
                    rowStart={{default: 8, m: 6}}
                >
                    <Checkbox 
                        text={WP.trans.dinnerRequest} 
                        name="dinner"
                        onChange={e => this.props.handleCheck(e)}
                        checked={dinner}
                    />
                </LastCheckboxGridElement>
                <GridElement
                    colStart={{default: 1, s: 1}}
                    colEnd={{default: 8, s: 12}}
                    rowStart={{default: 9, m: 7}}
                >
                    <TextArea 
                        name="message"
                        onChange={e => this.props.handleInputChange(e)}
                        label={capitalize(WP.trans.message)}
                        value={message}
                    />
                </GridElement>
            </FormGrid>
        )
    }
}

export default ConferenceOrderInput;


const FormGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .67fr) 1fr;
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[5] 1fr;
        grid-template-columns: repeat(5, 1fr .435fr) 1fr;
    `}
`

const VenueGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`

const PeopleGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`

const DatePickerGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`

const DaysGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};
    `}
`

const OptionsHtmlGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding-bottom: 0;
    `}
`

const OptionsHtml = styled(Html)`
    ${Media.greaterThan('s')`
        padding: 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM};
    `}
`

const CheckboxGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding: 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.contentM};
    `}
`

const LastCheckboxGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};

    ${Media.greaterThan('s')`
        padding: 0 ${props => props.theme.spacing.contentM} ${props => props.theme.spacing.elementS} ${props => props.theme.spacing.contentM};
    `}
`